module.exports = __webpack_public_path__ + "static/media/0010_IMG_LE_PLAFOND_RAL_9010.80158f7a.png";